<template>
    <div class="document-section">
        <h3 class="fs-16 fw-bold clr-title mb-4">Uploaded Documents</h3>
        <div v-if="loading" class="text-center p-4">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading comments...</span>
            </div>
        </div>
        <div v-else class="row">
            <div v-if="documents.length === 0" class="text-center p-4 text-muted">
                No documents available
            </div>
            <template v-else>
                <div  class="col-md-6 col-lg-4 mb-4"  v-for="(file, index) in documents"
                        :key="index">
                    <div class="ticket_documentInfo d-flex align-items-center gap-3 h-100">
                        <div class="icon-wrapper flex-shrink-0">
                            <img src="./../../../assets/images/quotes.svg" alt="pdf icon" class="w-100 h-100" />
                        </div>
                        <div class="document_content d-flex flex-column gap-1 flex-grow-1">
                            <a :href="file.url" target="_blank"
                                class="document_link d-flex align-items-center gap-1 justify-content-between">
                                <span class="document_name clr-primary fw-semibold text-truncate text-nowrap" 
                                >{{ file.original_file_name }}</span>
                                <span
                                    class="link_icon d-flex align-items-center justify-content-center clr-primary font-14">
                                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </span>
                            </a>
                            <div class="document_info d-flex align-items-center gap-2 flex-wrap font-14">
                                <span class="dots"> </span>
                                <span class="document_datewrapper clr-title fw-medium">
                                        Uploaded :
                                        <span class="document_date clr-bold-grey fw-normal">{{ formatDate(file.updated_at) }}</span>
                                    </span>
                                <!-- <span class="dots"> </span>
                                    <span class="document_datewrapper clr-title fw-medium">
                                        Size :
                                        <span class="document_date clr-bold-grey fw-normal">{{ file.file_size }}{{ file.size_unit }}</span>
                                    </span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>

</template>

<script>
import axios from 'axios';
import Helper from '@/resource/Helper';

export default {
    name: "TicketIssueDocument",
    props: {
        ticketData: {
            type: Object,
            required: true
        },
        formatDate: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            documents: [],
            newDocument: "",
            loading: false,
            submitting: false,
            error: null

        };
    },
    computed: {
        issueId() {
            return this.$route.params.ticketId;
        }
    },
    methods: {
        async fetchDocuments() {
            this.loading = true;
            this.error = null;

            try {
                console.log('Fetching documents for issue:', this.issueId);
                const response = await axios.get(
                    `${process.env.VUE_APP_TICKETING_URL}v2/agent/issues/${this.issueId}/documents`,
                    {
                        headers: {
                            'X-Authorization': Helper.messageCenterToken(),
                            'X-Ticketing-Token': Helper.ticketingToken()
                        }
                    }
                );
                this.documents = response.data.data.data;
                console.log('Documents:', this.documents);
            } catch (error) {
                console.error('Error fetching documents:', error);
                this.error = error.message;
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.fetchDocuments();
    },
};
</script>

<style scoped>
.document-section .ticket_documentInfo {
    padding: 16px;
    border: 1px solid #d7e1ea;
    border-radius: 6px;
}

.document-section .ticket_documentInfo .icon-wrapper {
    width: 34px;
}

.document-section .ticket_documentInfo .document_content .document_info .dots {
    background-color: #a6a6a6;
    width: 5px;
    height: 5px;
    border-radius: 50%;
}
</style>
